// Autogenerated file
export const bidPointTypesEnum = {
    StartPoint: "StartPoint",
    LoadPoint: "LoadPoint",
    UnloadPoint: "UnloadPoint",
    CustomPoint: "CustomPoint",
    ServicePoint: "ServicePoint",
};
export const bidPointTypes = [
    { label: "Нулевая точка", value: "StartPoint" },
    { label: "Точка загрузки", value: "LoadPoint" },
    { label: "Точка выгрузки", value: "UnloadPoint" },
    { label: "Произвольная точка", value: "CustomPoint" },
    { label: "Точка сервисных работ", value: "ServicePoint" },
];
